import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
})
export class VideoPlayerComponent implements OnInit, OnChanges {
  @Input() videoHtml: string;

  @Input() videoShowing: boolean = false;
  @Output() videoShowingChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() videoError = false;

  @ViewChild('videoContainer') videoContainer: ElementRef;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      !changes.videoHtml?.isFirstChange() &&
      changes.videoHtml?.previousValue != changes.videoHtml?.currentValue &&
      this.videoContainer
    ) {
      this.videoContainer.nativeElement.innerHTML = changes.videoHtml.currentValue;
    }
  }

  ngOnInit(): void {}

  changeVideoValue(open: boolean) {
    this.videoShowing = open;
    this.videoShowingChange.emit(open);
  }

  closeVideo() {
    this.changeVideoValue(false);
  }
}
